import React, { useState } from 'react';
import T from 'prop-types';
// components
import QuestionRow from '../QuestionRow';
import CategoryRollUp from '../CategoryRollUp';
// utils
import { shouldRevealSVRCategoryQuestions } from 'utils/SVRHelper';

const MobileCategoryQuestions = ({ currentCategory, categoryIndex, isDraft, categoryPassAll, onAllPassed }) => {
  // Categories answered individually or left incomplete start revealed,
  // untouched or fully passed ones stay behind the roll-up.
  // With pass-all off there is no roll-up and every question is shown right away
  const [isQuestionsVisible, setQuestionsVisible] = useState(() => (
    !isDraft || !categoryPassAll || shouldRevealSVRCategoryQuestions(currentCategory)
  ));

  const handleRollUpConfirm = (hasRemainingQuestions) => {
    setQuestionsVisible(hasRemainingQuestions);
    // Fully passed category needs nothing else on this step - move on
    if (!hasRemainingQuestions && onAllPassed) onAllPassed();
  };

  return (
    <div>
      <CategoryRollUp
        category={currentCategory}
        categoryIndex={categoryIndex}
        areQuestionsVisible={isQuestionsVisible}
        onConfirm={handleRollUpConfirm}
        onDecline={() => setQuestionsVisible(true)}
      />
      {isQuestionsVisible && currentCategory.svr_questions.map((question, questionIndex) => (
        <QuestionRow
          categoryIndex={categoryIndex}
          key={question.id}
          question={question}
          questionIndex={questionIndex}
        />
      ))}
    </div>
  );
};

MobileCategoryQuestions.propTypes = {
  currentCategory: T.object.isRequired,
  categoryIndex: T.number.isRequired,
  isDraft: T.bool,
  categoryPassAll: T.bool,
  onAllPassed: T.func,
};

export default MobileCategoryQuestions;
